'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



/*****************
 ** WEBPACK FOOTER
 ** ./~/algoliasearch/~/querystring/index.js
 ** module id = 89
 ** module chunks = 0
 **/